/**
 * OOS swatch fix (works with bundle-head.js).
 *
 * Map keys from Liquid:
 *   "color|length"           -> true if ANY child (e.g. width) is in stock
 *   "color|length|width"     -> exact combo (3-option products)
 *   "color|initial"          -> 2-option products (pendants)
 */
(function () {
  function parseMap(root) {
    var mapEl = root.querySelector('script[data-option-availability]');
    if (!mapEl) return null;
    try {
      return JSON.parse(mapEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function setOos(label, sellable) {
    label.classList.toggle('disabled', !sellable);
    label.classList.toggle('is-oos', !sellable);
  }

  function checkedValue(fieldset) {
    var input = fieldset && fieldset.querySelector('input:checked');
    return input ? input.value : null;
  }

  function applyRoot(root, option1Override) {
    if (!root) return;
    var map = parseMap(root);
    if (!map) return;

    var fieldsets = root.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;

    var option1 = option1Override || checkedValue(fieldsets[0]);
    if (!option1) return;

    // 2nd option (Length / Initial): available if ANY combo under this pair is in stock
    fieldsets[1].querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      var sellable = map[option1 + '|' + input.value] === true;
      setOos(label, sellable);
    });

    // 3rd option (Width): exact combo for selected color + length
    if (fieldsets.length >= 3) {
      var option2 = checkedValue(fieldsets[1]);
      if (!option2) return;

      fieldsets[2].querySelectorAll('label').forEach(function (label) {
        var input = label.querySelector('input');
        if (!input) return;
        var sellable = map[option1 + '|' + option2 + '|' + input.value] === true;
        setOos(label, sellable);
      });
    }
  }

  function applyAll() {
    document.querySelectorAll('variant-radios').forEach(function (root) {
      applyRoot(root);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    applyAll();
    setTimeout(applyAll, 0);
    setTimeout(applyAll, 50);
    setTimeout(applyAll, 200);
    setTimeout(applyAll, 600);
    window.addEventListener('load', applyAll);
  });

  document.addEventListener(
    'change',
    function (e) {
      var root = e.target && e.target.closest && e.target.closest('variant-radios');
      if (!root) return;
      setTimeout(function () {
        applyRoot(root);
      }, 0);
      setTimeout(function () {
        applyRoot(root);
      }, 50);
    },
    true
  );

  document.addEventListener(
    'mouseover',
    function (e) {
      var label =
        e.target &&
        e.target.closest &&
        e.target.closest('variant-radios fieldset.option-first label');
      if (!label) return;
      var root = label.closest('variant-radios');
      var input = label.querySelector('input');
      if (!root || !input) return;
      applyRoot(root, input.value);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var label =
        e.target &&
        e.target.closest &&
        e.target.closest('variant-radios fieldset.option-first label');
      if (!label) return;
      var root = label.closest('variant-radios');
      if (!root) return;
      applyRoot(root);
    },
    true
  );
})();
